<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
		<g id="Component_68_3602" data-name="Component 68 – 3602">
			<rect id="Rectangle_9086" data-name="Rectangle 9086" width="28" height="28" rx="8" fill="transparent" />
		</g>
		<path
			id="Path_21003"
			data-name="Path 21003"
			d="M7.608,14.431v3.477H5v-.869H6.738V16.6H5.869v-.869h.869V15.3H5v-.869Zm0-5.216v1.572l-1.738.869v.166H7.608v.869H5V11.12l1.738-.869v-.166H5V9.216ZM6.738,4V7.477H5.869V4.869H5V4Z"
			transform="translate(1.001 3.001)"
			fill="#5a677d"
			fill-rule="evenodd"
		/>
		<line
			id="Line_871"
			data-name="Line 871"
			x2="11.215"
			transform="translate(12.051 8.426)"
			fill="none"
			stroke="#5a677d"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="1.2"
		/>
		<line
			id="Line_872"
			data-name="Line 872"
			x2="11.215"
			transform="translate(12.051 13.957)"
			fill="none"
			stroke="#5a677d"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="1.2"
		/>
		<line
			id="Line_873"
			data-name="Line 873"
			x2="11.215"
			transform="translate(12.051 19.487)"
			fill="none"
			stroke="#5a677d"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="1.2"
		/>
	</svg>
</template>

<script>
export default {
	name: 'OrderedListSvg',
};
</script>

<style scoped lang="scss"></style>
